"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Services = _interopRequireDefault(require("../../Services"));

require("./style.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var Bubble2 = function Bubble2(props) {
  return _react.default.createElement("div", {
    className: "sl-bubble2"
  }, _react.default.createElement("div", {
    className: "sl-loader",
    style: {
      "--size": _Services.default.getZoom(props.size || 100)
    }
  }, _react.default.createElement("div", {
    className: "sl-loader-items"
  }, _toConsumableArray(Array(3).keys()).map(function (item, index) {
    return _react.default.createElement("div", {
      className: "sl-bubble",
      key: index,
      style: {
        "--i": ++index,
        "--bg": props.bgColor || "#FFFFFF"
      }
    });
  }))), props.title !== undefined ? _react.default.createElement("div", {
    className: "sl-loader-title",
    style: {
      "--cl": props.color || "#FFFFFF"
    }
  }, _react.default.createElement("span", null, props.title)) : null);
};

var _default = Bubble2;
exports.default = _default;